import React, { useEffect, useState } from "react";
import { Button, Input } from "../../components";
import { useLocation, useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { VerifyOtp, signupUser } from "../../redux/Slice/Auth/VerifyUserSlice";
import { ToastContainer, toast } from "react-toastify";
import { SendOTP, VerifySignup } from "../../utilities/api/auth/auth-service";

const OtpVerification = () => {
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [newOtp, setNewOtp] = useState("");
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(59);
  const [verifyButton, setVerifyButton] = useState(false)
  const { UserRole, ButtonDisable } = useAppSelector((state) => state.verifiedUser);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation().state;

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const handleClick = async () => {
    if (location.for === "signup") {
      setVerifyButton(true)
      const verifyOtp = await VerifySignup({
        phone: location.phone,
        otpNumber: otp.join("")
      })
      if (verifyOtp.status === 200) {
        dispatch(signupUser(verifyOtp))
      } else {
        toast.error(verifyOtp?.response?.data?.message || "Invalid or expired OTP")
      }
      setVerifyButton(false)
    } else {
      const result = await dispatch(VerifyOtp({ phone: location.phone, otpNumber: otp.join("") }));
      if (result.payload?.response?.status === 400) {
        toast.error(result.payload?.response?.data?.message || "Invalid or expired OTP");
      }
    }
  };

  useEffect(() => {

    if (UserRole?.role?.name === "SUPER_ADMIN") {
      navigate("/super-admin-dashboard");
    }
    if (UserRole?.role?.name === "OFFICE_ADMIN") {
      navigate("/office-admin-dashboard");
    }
    if (UserRole?.role?.name === "POS_ADMIN") {
      navigate("/pos-admin-dashboard");
    }
    if (UserRole?.role?.name === "END_USER") {
      navigate("/customer-dashboard");
    }
  });

  useEffect(() => {
    document.body.classList.add("verification-page");
    return () => {
      document.body.classList.remove("verification-page");
    };
  }, []);

  const handleChange = (element: any, index: number) => {
    if (isNaN(element.value)) return false;
    setOtp([...otp.map((ele, ind) => (ind === index ? element.value : ele))]);
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (e: any, index: number) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
        e.target.previousSibling?.focus();
      }
      e.preventDefault();
    }
  };

  const handleResendOtp = async () => {

    setMinutes(1);
    setSeconds(59);
    setOtp(new Array(4).fill(""));
    const result = await SendOTP({
      phone: location.phone,
      otpFor: location.for === "signup" ? "register" : "twoFactorAuth",
    });
    if (result?.status === 200) {
      setNewOtp(result.data.data.otpNumber);
    } else {
      toast.error(result?.response?.data?.message || "Failed to resend OTP");
    }
  };

  return (
    <form>
      <div className="container">
        <div
          className="row justify-content-center align-items-center"
          style={{ height: "84vh" }}
        >
          <div className="col-md-6">
            <div className="position-relative">
              <div className="card">
                <div className="card-body">
                  <h3 className="card-title mb-4 text-start">Verify Account</h3>

                  <p className="text-start">
                    {location?.message}
                  </p>

                  {newOtp ? newOtp : location?.otpNumber}
                  <div className="row">
                    <div className="col-md-8">
                      <div
                        id="otp"
                        className="inputs d-flex flex-row justify-content-center mt-2"
                      >
                        {otp.map((item, index) => {
                          return (
                            <Input
                              autoFocus={index === 0 ? true : false}
                              onChange={(e: any) => handleChange(e.target, index)}
                              onKeyDown={(e: any) => handleKeyDown(e, index)}
                              key={index + "otp input"}
                              onFocus={(e: any) => e.target.select()}
                              value={item}
                              maxLength="1"
                              placeholder="-"
                              name="otp"
                              className="text-center form-control me-2 py-4"
                              type="text"
                              id={`${index}indexotp`}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="align-items-center d-flex mt-4">
                    {" "}
                    <Button
                      type="submit"
                      className="btn btn-primary validate"
                      onClick={handleClick}
                      bname={(verifyButton || ButtonDisable) ? "Verifying" : "Verify"}
                      name="Verify"
                      id="verify"
                      disabled={otp.join("").length < 4 || verifyButton || ButtonDisable}
                    />

                    <Button
                      disabled={seconds > 0 || minutes > 0}
                      className="btn btn-link"
                      onClick={handleResendOtp}
                      bname="Resend Code"
                      name="resend-otp"
                      id="resend-otp"
                    />
                    <div className="text-start">
                      {minutes === 0 && seconds === 0 ? null : (
                        <>
                          {" "}
                          {minutes < 10 ? `0${minutes}` : minutes}:
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer limit={2} />
      </div>
    </form>
  );
};
export { OtpVerification };
